export default __webpack_public_path__ + "static/media/danger_icon.1a0fae75.svg";